import { X } from 'lucide-react';
import { Dialog } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Painel lateral (gaveta): navegação no celular e painéis de detalhe. */
export const Sheet = Dialog.Root;
export const SheetTrigger = Dialog.Trigger;
export const SheetClose = Dialog.Close;

type SheetContentProps = Omit<ComponentProps<typeof Dialog.Content>, 'title'> & {
  side?: 'left' | 'right';
  title: string;
  description?: string;
  /** Esconde o cabeçalho visualmente (continua disponível para leitores de tela). */
  hideHeader?: boolean;
  children: ReactNode;
};

export function SheetContent({
  side = 'right',
  title,
  description,
  hideHeader,
  className,
  children,
  ...props
}: SheetContentProps) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-(--z-index-overlay) bg-overlay motion-safe:data-[state=open]:animate-[fade-in_200ms_var(--ease-out)]" />
      <Dialog.Content
        className={cn(
          'fixed inset-y-0 z-(--z-index-modal) flex w-[min(20rem,88vw)] flex-col bg-surface-raised shadow-md outline-none',
          side === 'left'
            ? 'left-0 border-r border-border motion-safe:data-[state=open]:animate-[slide-in-left_220ms_var(--ease-out)]'
            : 'right-0 border-l border-border motion-safe:data-[state=open]:animate-[slide-in-right_220ms_var(--ease-out)]',
          className,
        )}
        {...props}
      >
        <div className={cn('px-4 pt-4 pr-14', hideHeader && 'sr-only')}>
          <Dialog.Title className="text-base font-bold">{title}</Dialog.Title>
          <Dialog.Description className={cn('mt-1 text-sm text-muted-foreground', !description && 'sr-only')}>
            {description ?? title}
          </Dialog.Description>
        </div>
        <Dialog.Close
          className="absolute top-3 right-3 inline-flex size-10 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
          aria-label="Fechar"
        >
          <X className="size-5" aria-hidden />
        </Dialog.Close>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  );
}
